/**
 * ÉCLAT FINE JEWELRY - CORE THEME INTERACTIVITY
 */

document.addEventListener('DOMContentLoaded', () => {
  initAccordions();
  initStickyHeader();
  initStickyAddToCart();
  initCurrencySelector();
});

/* 1. Luxury Accordions */
function initAccordions() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const parent = header.closest('.accordion-item');
      const isOpen = parent.classList.contains('is-open');
      
      // Close other accordions if desired in group
      const siblingAccordions = parent.parentElement.querySelectorAll('.accordion-item');
      siblingAccordions.forEach(item => item.classList.remove('is-open'));

      if (!isOpen) {
        parent.classList.add('is-open');
      }
    });
  });
}

/* 2. Sticky Header Elevation */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
}

/* 3. Sticky Add To Cart Bar on Scroll */
function initStickyAddToCart() {
  const mainAtcBtn = document.querySelector('.pdp-main-atc-button');
  const stickyBar = document.querySelector('.sticky-atc-bar');

  if (!mainAtcBtn || !stickyBar) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // If main button is out of viewport (scrolled past), show sticky bar
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainAtcBtn);
}

/* 4. Currency Selector (USD / CAD Toggle) */
function initCurrencySelector() {
  const currencyForms = document.querySelectorAll('.currency-selector-form');
  currencyForms.forEach(form => {
    const select = form.querySelector('select');
    if (select) {
      select.addEventListener('change', () => {
        form.submit();
      });
    }
  });
}
